/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetZoneDocument = gql`
    query GetZone($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      timeZone {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetZoneQuery__
 *
 * To run a query within a React component, call `useGetZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetZoneQuery(baseOptions: Apollo.QueryHookOptions<GetZoneQuery, GetZoneQueryVariables> & ({ variables: GetZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
      }
export function useGetZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
        }
export function useGetZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
        }
export type GetZoneQueryHookResult = ReturnType<typeof useGetZoneQuery>;
export type GetZoneLazyQueryHookResult = ReturnType<typeof useGetZoneLazyQuery>;
export type GetZoneSuspenseQueryHookResult = ReturnType<typeof useGetZoneSuspenseQuery>;
export type GetZoneQueryResult = Apollo.QueryResult<GetZoneQuery, GetZoneQueryVariables>;
export const GetEmployeesSheduleDocument = gql`
    query GetEmployeesShedule($page: Int!, $itemsPerPage: Int!, $name: String, $positionId: Int, $statusId: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    email
    company(id: $companyId) {
      employees(
        page: $page
        itemsPerPage: $itemsPerPage
        name: $name
        positionId: $positionId
        statusId: $statusId
      ) {
        totalCount
        currentPage
        pageCount
        employees {
          id
          status {
            id
            name
          }
          name
          surname
          email
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesSheduleQuery__
 *
 * To run a query within a React component, call `useGetEmployeesSheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesSheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesSheduleQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      name: // value for 'name'
 *      positionId: // value for 'positionId'
 *      statusId: // value for 'statusId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmployeesSheduleQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables> & ({ variables: GetEmployeesSheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>(GetEmployeesSheduleDocument, options);
      }
export function useGetEmployeesSheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>(GetEmployeesSheduleDocument, options);
        }
export function useGetEmployeesSheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>(GetEmployeesSheduleDocument, options);
        }
export type GetEmployeesSheduleQueryHookResult = ReturnType<typeof useGetEmployeesSheduleQuery>;
export type GetEmployeesSheduleLazyQueryHookResult = ReturnType<typeof useGetEmployeesSheduleLazyQuery>;
export type GetEmployeesSheduleSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSheduleSuspenseQuery>;
export type GetEmployeesSheduleQueryResult = Apollo.QueryResult<GetEmployeesSheduleQuery, GetEmployeesSheduleQueryVariables>;
export type GetZoneQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetZoneQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null } | null } | null };

export type GetEmployeesSheduleQueryVariables = Types.Exact<{
  page: Types.Scalars['Int']['input'];
  itemsPerPage: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  positionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  statusId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetEmployeesSheduleQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, company?: { __typename?: 'CompanyProxy', employees?: { __typename?: 'EmployeePaginated', totalCount?: number | null, currentPage?: number | null, pageCount?: string | null, employees?: Array<{ __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, email: string, phone: string, status?: { __typename?: 'EmployeeStatusProxy', id: number, name?: string | null } | null }> | null } | null } | null } | null };
